<template>
  <span class="resource-label-directive truncate-text"
    ><span>{{ resource.name }}</span></span
  >
</template>

<script>
// Vue equivalent of the `resourceLabel` Angular directive, for use inside Vue templates.
// Both of the directive's Angular hosts - the booking typeahead templates and resourceSingle -
// are now gone, so the directive is hostless; step 18 deletes it.
export default {
  name: 'ResourceLabelComponent',
  props: {
    resource: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
